import React, { createContext, useContext, useState, useCallback } from 'react';

const TransformContext = createContext();

export function TransformProvider({ children }) {
    const [transformMode, setTransformMode] = useState('translate');
    const [transformingObjects, setTransformingObjects] = useState(new Set());
    const [snapToGrid, setSnapToGrid] = useState(false);
    const [gridSize, setGridSize] = useState(0.1);

    const startTransform = useCallback((objectId) => {
        setTransformingObjects(prev => new Set(prev).add(objectId));
    }, []);

    const endTransform = useCallback((objectId) => {
        setTransformingObjects(prev => {
            const next = new Set(prev);
            next.delete(objectId);
            return next;
        });
    }, []);

    const toggleSnapToGrid = useCallback(() => {
        setSnapToGrid(prev => !prev);
    }, []);

    const adjustGridSize = useCallback((size) => {
        setGridSize(size);
    }, []);

    const snapValueToGrid = useCallback((value) => {
        if (!snapToGrid) return value;
        return Math.round(value / gridSize) * gridSize;
    }, [snapToGrid, gridSize]);

    return (
        <TransformContext.Provider value={{
            transformMode,
            setTransformMode,
            isTransforming: transformingObjects.size > 0,
            startTransform,
            endTransform,
            snapToGrid,
            toggleSnapToGrid,
            gridSize,
            adjustGridSize,
            snapValueToGrid
        }}>
            {children}
        </TransformContext.Provider>
    );
}

export function useTransform() {
    const context = useContext(TransformContext);
    if (!context) {
        throw new Error('useTransform must be used within a TransformProvider');
    }
    return context;
} 